import { render, staticRenderFns } from "./appointment-four.vue?vue&type=template&id=188c3dca&scoped=true"
import script from "./appointment-four.vue?vue&type=script&lang=js"
export * from "./appointment-four.vue?vue&type=script&lang=js"
import style0 from "./appointment-four.vue?vue&type=style&index=0&id=188c3dca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c3dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188c3dca')) {
      api.createRecord('188c3dca', component.options)
    } else {
      api.reload('188c3dca', component.options)
    }
    module.hot.accept("./appointment-four.vue?vue&type=template&id=188c3dca&scoped=true", function () {
      api.rerender('188c3dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/softBusinessLogistics/appointment-four.vue"
export default component.exports